import {useFetch} from "../useFetch";
import {GetDataForPanelDto} from "../../types/api/map/map.types";
import {mapService} from "../../services/map/map-service";


export const useFetchPanelData = () => {
    const { isLoading, error, data, refetch } = useFetch<GetDataForPanelDto>(mapService.panelData);

    return { data: data as GetDataForPanelDto, isLoading, error, refetch };
}